// Copyright (c) Docugami, Inc. All rights reserved.

import { useNavigationService, NavigationType } from "hooks/navigationService";
import { useUploadProgress } from "hooks/UploadProgress";
import { NotificationCategory, NotificationType } from "networking/NotificationsApi";
import { useEffect, useState } from "react"
import { NotificationItemClickedSchema, TelemetryEvent } from "telemetry/TelemetryEvents";
import { Telemetry } from "telemetry/TelemetryManager";
import { IProgressVisual, NotificationItem, NotificationItemProps } from "./NotificationItem";

interface FileUploadNotificationProps {
    startTime: Date
}

export const FileUploadNotification = (props: FileUploadNotificationProps): JSX.Element => {
    const { isUploading, uploadStats } = useUploadProgress();
    const [message, setMessage] = useState('');
    const [progressVisual, setProgressVisual] = useState<IProgressVisual>();
    const navService = useNavigationService();


    function primaryAction() {
        Telemetry.trackEvent<NotificationItemClickedSchema>({
            id: 'OpenDoxExplorer',
            category: NotificationCategory.Other,
            type: NotificationType.FileUpload,
            eventName: TelemetryEvent.NotificationItemClicked
        });

        navService.navToLocalDocs(NavigationType.PushNewPage)
    }

    useEffect(() => {
        const newMessage = uploadStats.totalCount > 1 ? 'Uploading your files' : 'Uploading your file';
        setMessage(newMessage);

        const visual: IProgressVisual | undefined = isUploading ? { progress: uploadStats.percentComplete } : undefined;
        setProgressVisual(visual);
    }, [isUploading, uploadStats])

    const itemProps: NotificationItemProps = {
        primaryAction: { action: primaryAction, label: 'View' },
        message: message,
        createdAt: props.startTime,
        isRead: true,
        progressVisual: progressVisual
    }

    return <NotificationItem {...itemProps} />
}
